import React from 'react';
import TextArea from 'devextreme-react/text-area';

export const DocumentKeyTextArea = ({
  field,
  form: { touched, errors, setFieldValue },
  ...props
}) => {
  const { col, label, onChange, required, height = 100 } = props;

  return (
    <div className={`col-lg-${col}`}>
      <div className={`form-group ${errors[field.name] ? 'has-error' : null}`}>
        <label className="control-label">
          {label}
          {required && <span className="text-danger"> * </span>}
        </label>
        <TextArea
          onValueChanged={option => {
            setFieldValue(field.name, option ? option.value : '');

            onChange && onChange(option);
          }}
          {...field}
          {...props}
          height={height}
          placeholder="Cole as chaves separadas por ';' ou linhas"
        />

        {touched[field.name] && errors[field.name] && (
          <span className="help-block m-b-none">{errors[field.name]}</span>
        )}
      </div>
    </div>
  );
};
